export const roomData = {
  'bedroom': {
    name: 'Bedroom',
    baseColor: '#6b4f8a',
    baseImage: '/Room/Bedroom/base.png',
    surfaces: [
      { id: 'wall1', name: 'Wall 1', mask: '/Room/Bedroom/wall1.png' },
      { id: 'wall2', name: 'Wall 2', mask: '/Room/Bedroom/wall2.png' },
      { id: 'wall3', name: 'Wall 3', mask: '/Room/Bedroom/wall3.png' },
    ],
  },
  'living-room': {
    name: 'Living Room',
    baseColor: '#883f3f',
    baseImage: '/Room/Living%20Room/base.png',
    surfaces: [
      { id: 'wall4', name: 'Wall 4', mask: '/Room/Living%20Room/wall4.png' },
      { id: 'wall1', name: 'Wall 1', mask: '/Room/Living%20Room/wall1.png' },
      { id: 'wall2', name: 'Wall 2', mask: '/Room/Living%20Room/wall2.png' },
      { id: 'wall3', name: 'Wall 3', mask: '/Room/Living%20Room/wall3.png' },
    ],
  },
  'kids-room': {
    name: 'Kids Room',
    baseColor: '#5a7c65',
    baseImage: '/Room/Kids%20Room/base.png',
    surfaces: [
      { id: 'wall1', name: 'Wall 1', mask: '/Room/Kids%20Room/wall1.png' },
      { id: 'wall2', name: 'Wall 2', mask: '/Room/Kids%20Room/wall2.png' },
      { id: 'wall3', name: 'Wall 3', mask: '/Room/Kids%20Room/wall3.png' },
    ],
  },
  'study': {
    name: 'Study',
    baseColor: '#7a6b5a',
    baseImage: '/Room/Study/base.png',
    surfaces: [
      { id: 'wall1', name: 'Wall 1', mask: '/Room/Study/wall1.png' },
      { id: 'wall2', name: 'Wall 2', mask: '/Room/Study/wall2.png' },
      { id: 'wall3', name: 'Wall 3', mask: '/Room/Study/wall3.png' },
    ],
  },
};